<ng-container *ngIf="active">
  <div class="alert-location alert-{{ alertSpecs.location }}">
    <ngb-alert #globalAlert [type]="alertSpecs.type" (closed)="active = false">
      {{ alertSpecs.message }}
    </ngb-alert>
  </div>
</ng-container>
